import { render, staticRenderFns } from "./infoForm.vue?vue&type=template&id=91dbbf54&scoped=true"
import script from "./infoForm.vue?vue&type=script&lang=js"
export * from "./infoForm.vue?vue&type=script&lang=js"
import style0 from "./infoForm.vue?vue&type=style&index=0&id=91dbbf54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91dbbf54",
  null
  
)

export default component.exports